import NotFound from '@src/pages/NotFound';
import { createFileRoute } from '@tanstack/react-router';

import { loadContactName } from '../clientTitle';
import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute(
  '/_app/clients/representatives/$contactId/history',
)({
  loader: async ({ context, params }) => ({
    contactName: await loadContactName(context.apiClient, params.contactId),
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'clients.contact_history.page_title',
          'Client Contact History',
          loaderData?.contactName ?? '',
        ),
      },
    ],
  }),
  // A contact that does not exist or that the user may not view.
  notFoundComponent: NotFound,
});
